var scope_0 = require('/Users/el_ade/Sites/2022/turista/turista-provincias/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/12a2c8af11dce1b8523806941c9577be.js').default;
var scope_1 = require('/Users/el_ade/Sites/2022/turista/turista-provincias/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6363c6a570e33c4cf112f1190258a994.js').default;
var scope_2 = require('/Users/el_ade/Sites/2022/turista/turista-provincias/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    